import { ActionTree } from 'vuex'
import axios from 'axios'
import _get from 'lodash/get'

import { BASE_URL } from '@/config'
import { BooksState } from './types'
import { RootState } from '../types'

export const actions: ActionTree<BooksState, RootState> = {
  getByISBN({ commit }, keyword): any {
    const path = `${BASE_URL}/books/by-isbn`
    const params = {
      isbn: keyword,
    }
    commit('setSearchKeyword', keyword)
    commit('setRequestSearchBook', true)
    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || null
        commit('setBestBook', data)
        return data
      })
      .catch(err => {
        commit('setBestBook', null)
        throw err
      })
  },
  getConditions({ commit }, payload): any {
    const path = `${BASE_URL}/books/conditions`
    return axios
      .get(path)
      .then(response => {
        const data = _get(response, 'data') || []
        commit('setConditions', {
          conditions: data,
          offset: payload.offset,
        })
        return data
      })
      .catch(err => {
        commit('setConditions', {
          conditions: [],
          offset: payload.offset,
        })
        throw err
      })
  },
  getGuidePrices({ commit }, payload): any {
    const path = `${BASE_URL}/books/guide-prices`
    const params = {
      bookId: payload.bookId,
      limit: payload.limit || 20,
      offset: payload.offset || 0,
      order: payload.order || [],
    }

    commit('setRequestGetGuidePrices', true)

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || []
        commit('setGuidPrices', {
          guidePrices: data,
          offset: payload.offset,
        })
        return data
      })
      .catch(err => {
        commit('setGuidPrices', {
          guidePrices: [],
          offset: payload.offset,
        })
        throw err
      })
  },
}
